import { uuidv7 } from "uuidv7";
import api from "api";

const mediaApiBase = process.env.REACT_APP_API_URL_V2 + "/v2/support/media";

const uploadFile = async (file: File, language?: string) => {
  var fileName = uuidv7();

  if (file.type === "video/mp4") {
    fileName += ".mp4";
  } else if (file.type === "text/vtt") {
    if (!language) {
      throw new Error("Language is required for caption files");
    }
    fileName = fileName += ".vtt";
  } else if (file.type === "image/svg+xml") {
    fileName += ".svg";
  } else if (file.type === "image/gif") {
    fileName += ".gif";
  } else if (file.type === "image/jpeg") {
    fileName += ".jpg";
  } else if (file.type === "image/png") {
    fileName += ".png";
  } else {
    throw new Error("Unsupported file type");
  }

  try {
    // @ts-ignore
    const fileUploadConfig = await api.parse(`POST /exercises/upload/presign`, {
      root: mediaApiBase,
      data: {
        content_type: file.type,
        file_name: fileName,
        scope: "joint_academy",
        caption_language: language,
      },
    });

    console.log("File upload config:", fileUploadConfig);
    // @ts-ignore
    const fileUploadUrl = fileUploadConfig.upload_url;
    // @ts-ignore
    const fileUploadValues = fileUploadConfig.upload_fields;
    // @ts-ignore
    const fileUrl = fileUploadConfig.object_url;

    const formData = new FormData();
    Object.entries(fileUploadValues).forEach(([key, value]) => {
      formData.append(key, value as string);
    });

    formData.append("file", file, fileName);
    console.log("Form data prepared for upload:", file, fileName, formData);

    const fileUploadResponse = await fetch(fileUploadUrl, {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
      },
    });
    console.log("File upload response:", fileUploadResponse);

    /* TODO: Make it possible to replace files names, then invalidate

    if (invalidate) {
      // @ts-ignore
      await api.parse(`POST /cloudfront/cache/invalidate`, {
        root: mediaApiBase,
        data: {
          paths: [`/${objectKey}`],
        },
      });
    }
    */

    return fileUrl;
  } catch (error) {
    console.error("Error fetching file upload config:", error);
  }
};
export default uploadFile;
